import { render, staticRenderFns } from "./member-item.vue?vue&type=template&id=48e9bab7&"
import script from "./member-item.vue?vue&type=script&lang=js&"
export * from "./member-item.vue?vue&type=script&lang=js&"
import style0 from "./member-item.vue?vue&type=style&index=0&id=48e9bab7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports